import { ReportImport } from './Import'
const { RoutesMap, InstalledEquipmentList, StockList, AuditLogList } = ReportImport

const ReportRoute = () => {
    return [
        {
            path: RoutesMap.INSTALLED_EQUIPMENT_LIST.path,
            element: <InstalledEquipmentList />
        },
        {
            path: RoutesMap.STOCK_REPORT_LIST.path,
            element: <StockList />
        },
        {
            path: RoutesMap.AUDIT_LOG_LIST.path,
            element: <AuditLogList />
        },
    ]
}

export default ReportRoute;